import { RoleDto } from './../../model/role-dto';
import { AppSettingService } from './../../services/app-setting.service';
import { PoOrderByPipe } from './../../pipes/po-order-by.pipe';
import { FileExportService } from '../../services/file-export.service';
import { Component, OnInit, AfterViewInit,OnDestroy  } from '@angular/core';
import { HttpclientService } from '../../services/httpclient.service';
import { Purchaseorderdto } from '../../model/purchageorderdto';
import { ActivatedRoute, Router, NavigationEnd  } from '@angular/router';
import { map, filter, switchMap } from 'rxjs/operators';
import { Distributor } from '../../model/distributor';
import { Customer } from '../../model/customer';
import { Status } from '../../model/status';
import { of } from 'rxjs';
import { UIStateService } from '../../services/ui-state.service';
import { distinct } from 'rxjs/operators';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { DatasharingService } from '../../services/datasharing.service';
import {AppValidationService } from '../../services/app-validation.service';
import * as FileSaver from 'file-saver';
declare var $: any;
@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  providers: [DatePipe],
  styleUrls: ['./purchase-order.component.css']
})
export class PurchaseOrderComponent implements OnInit, AfterViewInit, OnDestroy {
  public loading: boolean;
  purchaseorders: Purchaseorderdto[];
  orderDetailsCheck : string;
  originalPurchaseOrderList: Purchaseorderdto[];
  serachdetails: Purchaseorderdto[];
  clonedpurchaseorders: Purchaseorderdto[];
  cancelthesearach :  Purchaseorderdto[];
  intialPurchaseOrderListOne : Purchaseorderdto[];
  onlyOneCount :number = 1;
  config: any;
  count: number = 25;
  search: string = "";
  distributornames: any;
  isDistributorAvl = true;
  distributornamesClone : any;
  exportList: string[] = ['Excel','PDF' ];
  selectedPurchaseOrders: any = [];
  exportModal: string;
  customernames: any;
  customernamesClone : any;
  statusvalues: string[] = ['Open', 'Partial', 'Complete', 'Hold', 'Initiated', 'Cancelled' ];
  statusvaluesClone: any;
  daterange;
  uniqueArray: any;
  distributors: Distributor[] = [];
  customers: Customer[] = [];
  status: Status[] = [];
  selectedcustomer: string = "";
  selecteddistributor: string = "";
  selectedcustomer1: string = "";
  selectedstatus: string = "";
  start;
  end;
  numberofexecution: number = 0;
  username : string="";
  inOrderDetails : string;
  showMessage : string="";
  isLessOrMoreDate: string = "";
  selectedAllRow: boolean;
  isPurchaseOrder: boolean;
  ped: Purchaseorderdto[];

  maxDate: moment.Moment;

  sortOrderDateCol: string;
  showReset: boolean;
  isPartner = false;
  sortCollapsed: boolean;
  isFirstOrderDateSort: boolean;

  isOrderDateSortCollapsedUpArrow: boolean;
  isOrderDateSortCollapsedDownArrow: boolean;

  isPoNoSortCollapsedUpArrow: boolean;
  isPoNoSortCollapsedDownArrow: boolean;

  isBolNoSortCollapsedUpArrow: boolean;
  isBolNoSortCollapsedDownArrow: boolean;

  isInvoiceSortCollapsedUpArrow: boolean;
  isInvoiceSortCollapsedDownArrow: boolean;

  isCustomerSortCollapsedUpArrow: boolean;
  isCustomerSortCollapsedDownArrow: boolean;


  isDistributorSortCollapsedUpArrow: boolean;
  isDistributorSortCollapsedDownArrow: boolean;

  isSoldToSortCollapsedUpArrow: boolean;
  isSoldToSortCollapsedDownArrow: boolean;

  isStatusSortCollapsedUpArrow: boolean;
  isStatusSortCollapsedDownArrow: boolean;

  isTypeSortCollapsedUpArrow: boolean;
  isTypeSortCollapsedDownArrow: boolean;

  public intialPurchaseOrderList: Purchaseorderdto[];
  dateValitation = false;
  roleList:RoleDto[];
  isXmlDataNotAvailable = false;
  searchFlag=true;
  isDistributor:boolean;

  constructor(private httpclientService: HttpclientService, private route: ActivatedRoute,
              private router: Router, public fileExportService: FileExportService,
              private pipe: PoOrderByPipe, private datePipe: DatePipe, public appSettingService: AppSettingService,
              private datasharing : DatasharingService,
              private uiStateService: UIStateService, public appValidationService: AppValidationService
            ) {
              this.exportModal = this.exportList[0];
              this.isLessOrMoreDate ='';
              this.initialSortValue();
              // if (sessionStorage.getItem('isPartner') === '1') {
              //   this.isPartner = true;
              // } else {
              //   this.isPartner = false;
              // }

              this.config = {
      currentPage: 1,
      itemsPerPage: 25
    };

    this.isDistributor = sessionStorage.getItem('roleId')!='6' ? true : false;    
  }



initialSortValue() {
  this.isOrderDateSortCollapsedUpArrow = true;
  this.isOrderDateSortCollapsedDownArrow = true;
  this.isPoNoSortCollapsedUpArrow = true;
  this.isPoNoSortCollapsedDownArrow = true;
  this.isBolNoSortCollapsedUpArrow = true;
  this.isBolNoSortCollapsedDownArrow = true;
  this.isInvoiceSortCollapsedUpArrow = true;
  this.isInvoiceSortCollapsedDownArrow = true;
  this.isCustomerSortCollapsedUpArrow = true;
  this.isCustomerSortCollapsedDownArrow = true;
  this.isDistributorSortCollapsedUpArrow = true;
  this.isDistributorSortCollapsedDownArrow = true;
  this.isSoldToSortCollapsedUpArrow = true;
  this.isSoldToSortCollapsedDownArrow = true;
  this.isStatusSortCollapsedUpArrow = true;
  this.isStatusSortCollapsedDownArrow = true;
  this.isTypeSortCollapsedUpArrow = true;
  this.isTypeSortCollapsedDownArrow = true;
}

// clear selection
clearPurchaseOrderSelection: Purchaseorderdto[];
clearAllSelection() {
  this.selectedAllRow = false;
  this.clearPurchaseOrderSelection = [];
  this.purchaseorders.forEach(pdto => {
    pdto.rowCheck = false;
    this.clearPurchaseOrderSelection.push(pdto);
  });
  this.purchaseorders = this.clearPurchaseOrderSelection;
}




  sortArry: Purchaseorderdto[];
  onChangeSort(event: any, upDown: boolean, propertyName: string) {
    if (propertyName === 'poReceivedDateTime' ) {
      this.isPoNoSortCollapsedUpArrow = true;
      this.isPoNoSortCollapsedDownArrow = true;
      this.isBolNoSortCollapsedUpArrow = true;
      this.isBolNoSortCollapsedDownArrow = true;
      this.isInvoiceSortCollapsedUpArrow = true;
      this.isInvoiceSortCollapsedDownArrow = true;
      this.isCustomerSortCollapsedUpArrow = true;
      this.isCustomerSortCollapsedDownArrow = true;
      this.isDistributorSortCollapsedUpArrow = true;
      this.isDistributorSortCollapsedDownArrow = true;
      this.isSoldToSortCollapsedUpArrow = true;
      this.isSoldToSortCollapsedDownArrow = true;
      this.isStatusSortCollapsedUpArrow = true;
      this.isStatusSortCollapsedDownArrow = true;
      this.isTypeSortCollapsedUpArrow = true;
      this.isTypeSortCollapsedDownArrow = true;
      if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, upDown);
    console.log(this.sortArry[0].poReceivedDateTime);
    this.purchaseorders = [];
    this.purchaseorders = this.sortArry;
    this.isOrderDateSortCollapsedUpArrow = !this.isOrderDateSortCollapsedUpArrow;
    this.isOrderDateSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, upDown);
  console.log(this.sortArry[0].poReceivedDateTime);
  this.purchaseorders = [];
  this.purchaseorders = this.sortArry;
  this.isOrderDateSortCollapsedDownArrow = !this.isOrderDateSortCollapsedDownArrow;
  this.isOrderDateSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'purchaseOrderNumber' ) {
    this.isOrderDateSortCollapsedUpArrow = true;
    this.isOrderDateSortCollapsedDownArrow = true;
    this.isBolNoSortCollapsedUpArrow = true;
    this.isBolNoSortCollapsedDownArrow = true;
    this.isInvoiceSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedDownArrow = true;
    this.isCustomerSortCollapsedUpArrow = true;
    this.isCustomerSortCollapsedDownArrow = true;
    this.isDistributorSortCollapsedUpArrow = true;
    this.isDistributorSortCollapsedDownArrow = true;
    this.isSoldToSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, true);
    console.log(this.sortArry[0].poReceivedDateTime);
    this.purchaseorders = [];
    this.purchaseorders = this.sortArry;
    this.isPoNoSortCollapsedUpArrow = !this.isPoNoSortCollapsedUpArrow;
    this.isPoNoSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, false);
  console.log(this.sortArry[0].poReceivedDateTime);
  this.purchaseorders = [];
  this.purchaseorders = this.sortArry;
  this.isPoNoSortCollapsedDownArrow = !this.isPoNoSortCollapsedDownArrow;
  this.isPoNoSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'supplierDocReferenceNumber' ) {
    this.isOrderDateSortCollapsedUpArrow = true;
    this.isOrderDateSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedDownArrow = true;
    this.isCustomerSortCollapsedUpArrow = true;
    this.isCustomerSortCollapsedDownArrow = true;
    this.isDistributorSortCollapsedUpArrow = true;
    this.isDistributorSortCollapsedDownArrow = true;
    this.isSoldToSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, true);
    console.log(this.sortArry[0].poReceivedDateTime);
    this.purchaseorders = [];
    this.purchaseorders = this.sortArry;
    this.isBolNoSortCollapsedUpArrow = !this.isBolNoSortCollapsedUpArrow;
    this.isBolNoSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, false);
  console.log(this.sortArry[0].poReceivedDateTime);
  this.purchaseorders = [];
  this.purchaseorders = this.sortArry;
  this.isBolNoSortCollapsedDownArrow = !this.isBolNoSortCollapsedDownArrow;
  this.isBolNoSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'billDocNumber' ) {
    this.isOrderDateSortCollapsedUpArrow = true;
    this.isOrderDateSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedUpArrow = true;
    this.isBolNoSortCollapsedDownArrow = true;
    this.isBolNoSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedDownArrow = true;
    this.isCustomerSortCollapsedUpArrow = true;
    this.isCustomerSortCollapsedDownArrow = true;
    this.isDistributorSortCollapsedUpArrow = true;
    this.isDistributorSortCollapsedDownArrow = true;
    this.isSoldToSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, true);
    console.log(this.sortArry[0].poReceivedDateTime);
    this.purchaseorders = [];
    this.purchaseorders = this.sortArry;
    this.isInvoiceSortCollapsedUpArrow = !this.isInvoiceSortCollapsedUpArrow;
    this.isInvoiceSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, false);
  console.log(this.sortArry[0].poReceivedDateTime);
  this.purchaseorders = [];
  this.purchaseorders = this.sortArry;
  this.isInvoiceSortCollapsedDownArrow = !this.isInvoiceSortCollapsedDownArrow;
  this.isBolNoSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'customerName2' ) {
    this.isOrderDateSortCollapsedUpArrow = true;
    this.isOrderDateSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedUpArrow = true;
    this.isBolNoSortCollapsedDownArrow = true;
    this.isBolNoSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedDownArrow = true;
    this.isDistributorSortCollapsedUpArrow = true;
    this.isDistributorSortCollapsedDownArrow = true;
    this.isSoldToSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, true);
    console.log("property"+propertyName);
    this.purchaseorders = [];
    this.purchaseorders = this.sortArry;
    this.isCustomerSortCollapsedUpArrow = !this.isCustomerSortCollapsedUpArrow;
    this.isCustomerSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, false);
  console.log(this.sortArry[0].poReceivedDateTime);
  this.purchaseorders = [];
  this.purchaseorders = this.sortArry;
  this.isCustomerSortCollapsedDownArrow = !this.isCustomerSortCollapsedDownArrow;
  this.isCustomerSortCollapsedUpArrow = true;
}
   } else if (propertyName === 'supplierSoldToId' ) {
    this.isOrderDateSortCollapsedUpArrow = true;
    this.isOrderDateSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedUpArrow = true;
    this.isBolNoSortCollapsedDownArrow = true;
    this.isBolNoSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedDownArrow = true;
    this.isCustomerSortCollapsedDownArrow = true;
    this.isCustomerSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, true);
    console.log("property"+propertyName);
    this.purchaseorders = [];
    this.purchaseorders = this.sortArry;
    this.isDistributorSortCollapsedUpArrow = !this.isDistributorSortCollapsedUpArrow;
    this.isDistributorSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, false);
  console.log(this.sortArry[0].poReceivedDateTime);
  this.purchaseorders = [];
  this.purchaseorders = this.sortArry;
  this.isDistributorSortCollapsedDownArrow = !this.isDistributorSortCollapsedDownArrow;
  this.isDistributorSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'customerSoldToID' ) {
    this.isOrderDateSortCollapsedUpArrow = true;
    this.isOrderDateSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedDownArrow = true;
    this.isPoNoSortCollapsedUpArrow = true;
    this.isBolNoSortCollapsedDownArrow = true;
    this.isBolNoSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedDownArrow = true;
    this.isDistributorSortCollapsedUpArrow = true;
    this.isDistributorSortCollapsedDownArrow = true;
    this.isSoldToSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, true);
    console.log("property"+propertyName);
    this.purchaseorders = [];
    this.purchaseorders = this.sortArry;
    this.isSoldToSortCollapsedUpArrow = !this.isSoldToSortCollapsedUpArrow;
    this.isSoldToSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, false);
  console.log(this.sortArry[0].poReceivedDateTime);
  this.purchaseorders = [];
  this.purchaseorders = this.sortArry;
  this.isSoldToSortCollapsedDownArrow = !this.isSoldToSortCollapsedDownArrow;
  this.isSoldToSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'purchaseOrderQuantityStatusCodeID' ) {
    this.isPoNoSortCollapsedUpArrow = true;
    this.isPoNoSortCollapsedDownArrow = true;
    this.isBolNoSortCollapsedUpArrow = true;
    this.isBolNoSortCollapsedDownArrow = true;
    this.isInvoiceSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedDownArrow = true;
    this.isCustomerSortCollapsedUpArrow = true;
    this.isCustomerSortCollapsedDownArrow = true;
    this.isDistributorSortCollapsedUpArrow = true;
    this.isDistributorSortCollapsedDownArrow = true;
    this.isSoldToSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    this.isOrderDateSortCollapsedUpArrow =  true;
    this.isOrderDateSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, true);
    console.log("property"+propertyName);
    this.purchaseorders = [];
    this.purchaseorders = this.sortArry;
    this.isStatusSortCollapsedUpArrow = !this.isStatusSortCollapsedUpArrow;
    this.isStatusSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, false);
  console.log(this.sortArry[0].poReceivedDateTime);
  this.purchaseorders = [];
  this.purchaseorders = this.sortArry;
  this.isStatusSortCollapsedDownArrow = !this.isStatusSortCollapsedDownArrow;
  this.isStatusSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'poType' ) {
    this.isPoNoSortCollapsedUpArrow = true;
    this.isPoNoSortCollapsedDownArrow = true;
    this.isBolNoSortCollapsedUpArrow = true;
    this.isBolNoSortCollapsedDownArrow = true;
    this.isInvoiceSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedDownArrow = true;
    this.isCustomerSortCollapsedUpArrow = true;
    this.isCustomerSortCollapsedDownArrow = true;
    this.isDistributorSortCollapsedUpArrow = true;
    this.isDistributorSortCollapsedDownArrow = true;
    this.isSoldToSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    this.isOrderDateSortCollapsedUpArrow =  true;
    this.isOrderDateSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, true);
    console.log("property"+propertyName);
    this.purchaseorders = [];
    this.purchaseorders = this.sortArry;
    this.isTypeSortCollapsedUpArrow = !this.isTypeSortCollapsedUpArrow;
    this.isTypeSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.purchaseorders, propertyName, false);
  console.log(this.sortArry[0].poReceivedDateTime);
  this.purchaseorders = [];
  this.purchaseorders = this.sortArry;
  this.isTypeSortCollapsedDownArrow = !this.isTypeSortCollapsedDownArrow;
  this.isTypeSortCollapsedUpArrow = true;
}
  }



  }



  clearAllSort() {
    this.isPoNoSortCollapsedUpArrow = true;
    this.isPoNoSortCollapsedDownArrow = true;
    this.isBolNoSortCollapsedUpArrow = true;
    this.isBolNoSortCollapsedDownArrow = true;
    this.isInvoiceSortCollapsedUpArrow = true;
    this.isInvoiceSortCollapsedDownArrow = true;
    this.isCustomerSortCollapsedUpArrow = true;
    this.isCustomerSortCollapsedDownArrow = true;
    this.isDistributorSortCollapsedUpArrow = true;
    this.isDistributorSortCollapsedDownArrow = true;
    this.isSoldToSortCollapsedUpArrow = true;
    this.isSoldToSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    this.isOrderDateSortCollapsedUpArrow =  true;
    this.isOrderDateSortCollapsedDownArrow = true;
  }

  onSelectAllPo(values: any) {

    this.ped = [];
    if (values.currentTarget.checked) {
      this.purchaseorders.forEach(pdto => {
        pdto.rowCheck = true;
        this.ped.push(pdto);
      });
      this.purchaseorders = this.ped;
      this.fileExportService.selectedPoData = this.ped;
    } else {
      this.purchaseorders.forEach(pdto => {
        console.log('...' + pdto.rowCheck);
        pdto.rowCheck = false;
        this.ped.push(pdto);
      });
      this.purchaseorders = this.ped;
      this.fileExportService.selectedPoData = [];
    }

    // console.log( "..."+ values.currentTarget.checked);
  }

  getSearch() {
    // set active tab based on id tabId
    return this.search;
  }
  getDateRange(){
    return this.daterange;
  }
  getUserName(){
    return this.username;
  }
  getPurchaseorders() {
    // set active tab based on id tabId
    return this.purchaseorders;
  }
  getDistributornamesClone() {
    // set active tab based on id tabId
    return this.distributornamesClone;
  }
  getCustomernamesClone() {
    // set active tab based on id tabId
    return this.customernamesClone;
  }
  getStatusvaluesClone() {
    // set active tab based on id tabId
    return this.statusvaluesClone;
  }
  setSearch(search: string) {

    console.log('set search..'+search+"search flag.."+ this.searchFlag+'search this..'+this.search);
    // set active tab based on id tabId
    if(this.searchFlag){
    search=this.search;
    } else{
      search = '';
      this.search = '';
    }
  }
  setPurchaseorders(purchaseorders: Purchaseorderdto[]) {
    // set active tab based on id tabId
    purchaseorders=this.purchaseorders;
  }
  setDistributornamesClone(distributornamesClone : any) {
    // set active tab based on id tabId
    distributornamesClone=this.distributornamesClone;
  }
  setCustomernamesClone(customernamesClone : any) {
    // set active tab based on id tabId
    customernamesClone=this.customernamesClone;
  }
  setStatusvaluesClone(statusvaluesClone: any) {
    // set active tab based on id tabId
    statusvaluesClone=this.statusvaluesClone;
  }
  getIntialPurchaseOrderListOne(){
    return this.intialPurchaseOrderListOne;
  }
  setDateRange(dateRange:any){
    dateRange = this.daterange;
  }
setUserName(username : string){
  username = this.username;
}
  ngOnDestroy() {
    console.log(">>>>>>>>>>>>>>>>>>. in destroy method >>>>>>>>>>>>>");
    this.setSearch(this.search);
    this.setDateRange(this.daterange);
    this.setUserName(this.username);
    const currentState = { search: this.getSearch(), dateRange : this.getDateRange(), username : this.getUserName(),intialPurchaseOrderListOne : this.getIntialPurchaseOrderListOne()
    }
    console.log(this.uiStateService.setState(currentState));
    console.log(this.uiStateService.getState());
  }

  ngOnInit() {
    this.showReset= false;
    var fromOrderDetails;
      this.datasharing.isVisibleSource.subscribe((username: string) => {
        console.log('isVisible: ', username); // => true/false
        fromOrderDetails=username;
    });
    if(fromOrderDetails=="orderDetails"){
      this.orderDetailsCheck = fromOrderDetails;
      this.uiStateService.getState();
      const state = this.uiStateService.getState();
      this.search=state.search;
      this.daterange=state.dateRange;
      this.username=state.username;
      this.intialPurchaseOrderListOne = state.intialPurchaseOrderListOne;
      $(document).ready(
        // console.log("PoCOMp")
        () => {

          $(".optDroDwn li a").on("click", function () {
            let dropDwnVal = $(this).html();
            console.log(dropDwnVal, "thththt")
            $(this).parents(".btn").find("span").html(dropDwnVal)
            // alert("ji")
          })
          $(".liBlks .dropDownIcon").on("click", function () {
            let currentLis = $(this).parents(".liBlks");
            currentLis.find(".dropDownContent").slideToggle()
            // $(".liBlks .dropDownContent").slideUp()
            $(this).toggleClass("dropDownIcon").toggleClass("dropUpIcon");

          })
          let searchInp = $(".searchContr .searchInput");
          let searchCloseIcon = $(".searchCloseIcon")
          $(searchInp).on("focus", function () {
            $(".searchIcon").addClass("searchIconActive")
            $(".searchCloseIcon").fadeIn("slow")
          })
          $(searchInp).on("blur", function () {
            $(".searchIcon").removeClass("searchIconActive")
            $(".searchCloseIcon").fadeOut("slow")
          })
          $(searchCloseIcon).hover(function () {
            $(searchCloseIcon).toggleClass("searchCloseIconFocus")
          })
          $(searchCloseIcon).on("click", function () {
            // this.start= moment().subtract(90, 'days').format('MM-DD-YYYY'), this.end= moment().format('MM-DD-YYYY') ;
            $(".searchContr .searchCloseIcon").val("");
            $(".searchInput").val("");

            // $(".dateRangePicker").val(this.start +" - "+this.end);


          })
          $(".accDrpDwn1").on("click", function () {
            $(this).toggleClass("accDrpDwnIcnOpen").toggleClass("accDrpDwnIcn");
            let parentTr = $(this).parent("td").parent("tr");
            let closestAcc = parentTr.siblings(".accordionTR0");
            console.log(closestAcc)
            $(closestAcc).slideToggle(300);
            $(this).parents("tr").toggleClass("noBorder")

          });
          // $(".sortIcon").on("click", function () {
          //   $(this).toggleClass("srtIcnPosD");

          // });
          // $(".sortIcon").on("click", function () {
          //   if ($(this).hasClass("srtIcnPosD")) {
          //     $(this).toggleClass("srtIcnPosU");
          //   }
          // })

        }
      )

      if(state.search != "" && this.daterange.start != null && this.daterange.end !=null){
        this.inOrderDetails="orderDetails";
        this.isLessOrMoreDate = '';
        let startdate = this.daterange.start.format('YYYY-MM-DD');
        let enddate = this.daterange.end.format('YYYY-MM-DD');
        this.loading=true;
        
        this.httpclientService.datereangeselectionforpo(startdate, enddate, this.username, state.search).subscribe(          
          data => {
            this.loading = false;
            this.clearAllSort();
            this.purchaseorders=[];
            this.purchaseorders = data;

            this.removeDuplicates();
            this.numberofexecution = this.numberofexecution + 2;
            this.loading=false;
            this.inOrderDetails="";
          }
        )

      }
      else if(state.search != "" ){
      this.searchpobolinvoiceno("",state.search);
      }
      // else if(this.daterange.start == moment().subtract(90, 'days') && this.daterange.end == moment()){
      //   this.getPurchaseOrder();
      //         }
      else if(this.daterange.start != null && this.daterange.end !=null ){
        this.isLessOrMoreDate = '';
        this.isLessOrMoreDate ="";
        let startdate = this.daterange.start.format('YYYY-MM-DD');
        let enddate = this.daterange.end.format('YYYY-MM-DD');
        this.numberofexecution = this.numberofexecution + 2;
        this.loading=true;
        
        this.httpclientService.datereangeselectionforpo(startdate, enddate, this.username, null).subscribe(
          data => {
            this.loading = false;
            this.clearAllSort();
            this.purchaseorders=[];
            this.purchaseorders = data;

            this.removeDuplicates();

            this.loading=false;
            this.inOrderDetails="";
            this.isLessOrMoreDate ="";
          }
        )
      }

      // this.purchaseorders = state.purchaseorders;
      // this.distributornames = state.distributornamesClone;
      // this.customernames = state.customernamesClone;
      // this.statusvalues = state.statusvaluesClone;

    }

    else{


    this.exportModal = this.exportList[0];

    this.daterange = { start: moment().subtract(this.appSettingService.m2mDbDefaultSearchDaysLimit, 'days'), end: moment() };

    $(document).ready(
      // console.log("PoCOMp")
      () => {

        $(".optDroDwn li a").on("click", function () {
          let dropDwnVal = $(this).html();
          console.log(dropDwnVal, "thththt")
          $(this).parents(".btn").find("span").html(dropDwnVal)
          // alert("ji")
        })
        $(".liBlks .dropDownIcon").on("click", function () {
          let currentLis = $(this).parents(".liBlks");
          currentLis.find(".dropDownContent").slideToggle()
          // $(".liBlks .dropDownContent").slideUp()
          $(this).toggleClass("dropDownIcon").toggleClass("dropUpIcon");

        })
        let searchInp = $(".searchContr .searchInput");
        let searchCloseIcon = $(".searchCloseIcon")
        $(searchInp).on("focus", function () {
          $(".searchIcon").addClass("searchIconActive")
          $(".searchCloseIcon").fadeIn("slow")
        })
        $(searchInp).on("blur", function () {
          $(".searchIcon").removeClass("searchIconActive")
          $(".searchCloseIcon").fadeOut("slow")
        })
        $(searchCloseIcon).hover(function () {
          $(searchCloseIcon).toggleClass("searchCloseIconFocus")
        })
        $(searchCloseIcon).on("click", function () {
            console.log(" this.search.."+ this.search);
         // this.start= moment().subtract(90, 'days').format('MM-DD-YYYY'), this.end= moment().format('MM-DD-YYYY') ;
          $(".searchContr .searchCloseIcon").val("");
          $(".searchInput").val("");
          // this.search = '';

        //  $(".dateRangePicker").val(this.start +" - "+this.end);


        })
        $(".accDrpDwn1").on("click", function () {
          $(this).toggleClass("accDrpDwnIcnOpen").toggleClass("accDrpDwnIcn");
          let parentTr = $(this).parent("td").parent("tr");
          let closestAcc = parentTr.siblings(".accordionTR0");
          console.log(closestAcc)
          $(closestAcc).slideToggle(300);
          $(this).parents("tr").toggleClass("noBorder")

        });
        // $(".sortIcon").on("click", function () {
        //   $(this).toggleClass("srtIcnPosD");

        // });
        // $(".sortIcon").on("click", function () {
        //   if ($(this).hasClass("srtIcnPosD")) {
        //     $(this).toggleClass("srtIcnPosU");
        //   }
        // })

      }
    )
    if (this.purchaseorders == undefined) {
      this.getPurchaseOrder();

    }
  }
}
  ChangeSortOrder(exportData) {
    this.exportModal = exportData;

  }



  //  sortIconEvent(ev: any) {


  //   if (this.sortOrderDateCol === 'up') {
  //     this.sortOrderDateCol = 'down';

  //   } else  if (this.sortOrderDateCol === 'down') {
  //     this.sortOrderDateCol = 'up';
  //   }
  //     console.log('...ss'+this.sortOrderDateCol+'...'+ev.srcElement.attributes.class);

  //  }

 modalPopup : boolean=false;
  modalPopupString: string;
  pressingOK(){
    this.modalPopup=false;
  }

  export() {


    if (this.purchaseorders === null || this.purchaseorders.length === 0) {
     this.modalPopupString="No Data to Export";
      this.modalPopup=true;
      return;
    } else if (this.fileExportService.selectedPoData.length === 0 && this.purchaseorders.length !== 0) {



if (this.exportModal === 'PDF') {

        this.fileExportService.exportPoPdfAll('Purchase Orders',this.purchaseorders);
      } else if (this.exportModal === 'Excel') {

        this.selectedPurchaseOrders = [];
        this.purchaseorders.forEach(pdto => {
            let invoiceNo: any, customer: any,
            distributor: any, soldTo: any, poType: any, orderDate: any;
            if (pdto.billDocNumber === null) {
              invoiceNo = '';
            } else {
              invoiceNo = pdto.billDocNumber;
            }
            if (pdto.customerName2 === null) {
              customer = '';
            } else {
              customer = pdto.customerName2;
            }
            if (pdto.supplierSoldToId === null) {
              distributor = '';
            } else {
              distributor = pdto.supplierSoldToId;
            }

            if (pdto.customerSoldToID === null) {
              soldTo = '';
            } else {
              soldTo = pdto.customerSoldToID;
            }

            if (pdto.poType === 'PO') {
              poType = 'Standard';
            } else {
              poType = 'Return';
            }

            orderDate = this.datePipe.transform(pdto.poReceivedDateTime, this.appSettingService.globelDateFormat);

            // this.selectedPurchaseOrders.push({
            //   OrderDate: `` + orderDate, PONo: `${pdto.purchaseOrderNumber}`,
            //   BOLNo: `${pdto.supplierDocReferenceNumber}`, InvoiceNo: `` + invoiceNo, Customer: `` + customer,
            //   Distributor: `` + distributor, SoldTo: `` + soldTo,
            //   Status: `${pdto.purchaseOrderQuantityStatusCodeID}`, Type: `` + poType
            // });
            this.selectedPurchaseOrders.push({
              "Order Date": `` + orderDate, Status: `${pdto.purchaseOrderQuantityStatusCodeID}`,
              Customer: `` + customer, "PO No.": `${pdto.purchaseOrderNumber}`, Type: `` + poType,
              "Sold To": `` + soldTo,  Distributor: `` + distributor,
              "BoL No.": `${pdto.supplierDocReferenceNumber}`, "Invoice No.": `` + invoiceNo
            });

        });

        this.fileExportService.exportExcel(this.selectedPurchaseOrders, 'Purchase Orders');

      }



    } else {

      if (this.exportModal === 'PDF') {

        this.fileExportService.exportPoPdf('Purchase Orders');
      } else if (this.exportModal === 'Excel') {

        this.selectedPurchaseOrders = [];
        this.fileExportService.selectedPoData.forEach(pdto => {
          if (pdto.rowCheck) {
            // tslint:disable-next-line:one-variable-per-declaration
            let invoiceNo: any, customer: any,
            distributor: any, soldTo: any, poType: any, orderDate: any;
            if (pdto.billDocNumber === null) {
              invoiceNo = '';
            } else {
              invoiceNo = pdto.billDocNumber;
            }
            if (pdto.customerName2 === null) {
              customer = '';
            } else {
              customer = pdto.customerName2;
            }
            if (pdto.supplierSoldToId === null) {
              distributor = '';
            } else {
              distributor = pdto.supplierSoldToId;
            }

            if (pdto.customerSoldToID === null) {
              soldTo = '';
            } else {
              soldTo = pdto.customerSoldToID;
            }

            if (pdto.poType === 'PO') {
              poType = 'Standard';
            } else {
              poType = 'Return';
            }

            orderDate = this.datePipe.transform(pdto.poReceivedDateTime, this.appSettingService.globelDateFormat);

            // this.selectedPurchaseOrders.push({
            //   OrderDate: `` + orderDate, PONo: `${pdto.purchaseOrderNumber}`,
            //   BOLNo: `${pdto.supplierDocReferenceNumber}`, InvoiceNo: `` + invoiceNo, Customer: `` + customer,
            //   Distributor: `` + distributor, SoldTo: `` + soldTo,
            //   Status: `${pdto.purchaseOrderQuantityStatusCodeID}`, Type: `` + poType
            // });
            this.selectedPurchaseOrders.push({
              "Order Date": `` + orderDate, Status: `${pdto.purchaseOrderQuantityStatusCodeID}`,
              Customer: `` + customer, "PO No.": `${pdto.purchaseOrderNumber}`, Type: `` + poType,
              "Sold To": `` + soldTo,  Distributor: `` + distributor,
              "BoL No.": `${pdto.supplierDocReferenceNumber}`, "Invoice No.": `` + invoiceNo
            });
          }
        });

        this.fileExportService.exportExcel(this.selectedPurchaseOrders, 'Purchase Orders');

      }
    }
  }
  ngAfterViewInit() {
    this.maxDate = moment().add(0, 'days');
    console.log("---ngAfterViewInit() Demo---");


  }

  getPurchaseOrder() {
    let usernn;
     this.datasharing.isVisibleSource.subscribe((username: string) => {
      console.log('isVisible: ', username); // => true/false
      usernn=username;
  });
    if(usernn=="default value"){
      this.username = sessionStorage.getItem('username');

    }else{
      this.username=usernn;
    }
    this.numberofexecution = this.numberofexecution + 1;


    this.isLessOrMoreDate = "";
    this.maxDate = moment().add(0, 'days');
    //this.minDate = moment().subtract(90, 'days');
    // this.daterange = { start: moment().subtract(90, 'days'), end: moment()};
    this.loading = true;
    console.log("here >>>>>>>>>>>>>>>");
    
    this.httpclientService.getPurchaseOrder(this.username).subscribe(
      data => {
        this.purchaseorders =[];
        this.loading = false;
        this.purchaseorders = data.filter(function (currentElement) {
          return (currentElement.purchaseOrderQuantityStatusCodeID == 'Initiated' || currentElement.purchaseOrderQuantityStatusCodeID == 'Cancelled' || currentElement.purchaseOrderQuantityStatusCodeID == 'Open' || currentElement.purchaseOrderQuantityStatusCodeID == 'Partial' || currentElement.purchaseOrderQuantityStatusCodeID == 'Hold');
        });
        if(this.onlyOneCount == 1){
         this.intialPurchaseOrderListOne=data
        }
        this.intialPurchaseOrderList = data;
        this.originalPurchaseOrderList = data;
        this.removeDuplicates();
        //this.clonedpurchaseorders = Object.assign([{}], this.purchaseorders);
        this.clonedpurchaseorders = Object.assign([{}], data);
        this.cancelthesearach = Object.assign([{}], this.purchaseorders);
        this.numberofexecution = this.numberofexecution + 1;

      }
    )

  }

  pageChanged(event) {
    this.config.currentPage = event;
  }
  resetPO(event){
    console.log("Events", event);
    this.router.navigateByUrl('/DummyComponent', {skipLocationChange: true}).then(()=>
    this.router.navigate(["dashboard"]));
  }

  changerecordperpage(value) {

    this.config.itemsPerPage = value;
    this.count = value;
  }
  async  searchpobolinvoiceno(search,search1){
    let startdate1 = this.daterange.start.format('MM/DD/YYYY');
    let enddate1 = this.daterange.end.format('MM/DD/YYYY');
    
    console.log("Start Date range ========================== " + startdate1);
    console.log("End Date range ========================== " + enddate1);
    if(this.inOrderDetails != "orderDetails"){
    var search2;
    var search3='';
    console.log('search.lenght..'+this.search.length);
    if(search1 == ""){
      if(search.value == undefined || search.value == null || search.value == "" ){
        this.showMessage="Please Enter PO Number";
        return;
      } else if(this.search.length< 3) {
        this.showMessage='Please Enter Minimum 3 Characters';
      } else{
        search2=' '+search.value;

      }
    }else{
       search2 =search1;
    }
    if(search1 == ""){
      this.clearAllSelection();
    }

    this.distributors=[];
    this.customers=[];
    this.status=[];
    //this.daterange ='';

       
    if(search2 != undefined && search2 != null && search2 != "" ){
      this.showReset= true;
      this.loading=true;
      this.showMessage='';
      this.httpclientService.searchpobolinvoiceno(this.username,search2).subscribe(
      data => {
          this.serachdetails=data;
          console.log("Data validation.."+data.length);
          this.searchFlag =true;
          if(data.length > 0 ) {
          if(data[0].dateRangeValidation ===1) {
            console.log("1-->>"+data[0].dateRangeValidation);
            //this.daterange = { start: moment().subtract(this.appSettingService.m2mDbSearchKeyDaysLimit, 'days'), end: moment() };
            //this.daterange = { startdate1: moment(), enddate1: moment() };
            this.dateValitation = false;
          }
        }else{
          console.log("2-->> Data validation.."+data.length);
          // this.daterange = { start: moment().subtract(this.appSettingService.m2mDbSearchKeyDaysLimit, 'days'), end: moment() };
          // this.dateValitation = false;
        }
          this.purchaseorders=[];
          this.purchaseorders=data;
          
          
          let distributorlist: Purchaseorderdto[] = [];
          let len = this.purchaseorders.length;
          for (let i = 0; i < len; i++) {
            let srchOrderDate = this.datePipe.transform(this.purchaseorders[i].poReceivedDateTime, this.appSettingService.globelDatePickerInUSAFormat);
                     
            if(this.dateCheck(startdate1,enddate1,srchOrderDate))
            {
              distributorlist.push(this.purchaseorders[i]); 
            }
            
          }
          this.purchaseorders = distributorlist;
          //this.clonedpurchaseorders= Object.assign([{}], this.serachdetails);
          //this.removeDuplicates();
          this.clearAllSort();
          if(this.purchaseorders.length === 0) {
          this.showMessage = 'No Record Found';
        }
          this.loading=false;
      },
      () => console.log('Observer got a complete notification')      
  );
}
}
}

dateCheck(from,to,check) {

  var fDate,lDate,cDate;
  fDate = Date.parse(from);
  lDate = Date.parse(to);
  cDate = Date.parse(check);

  if((cDate <= lDate && cDate >= fDate)) {
      return true;
  }
  return false;
}

  removeDuplicates(){
    let len = this.purchaseorders.length;
    this.distributors=[];
    this.customers=[];
    this.status=[];
    for(let i=0;i<len ;i++){
      if(this.purchaseorders[i].payer1 != null){
      this.distributors.push(new Distributor(this.purchaseorders[i].supplierSoldToId));}
      if(this.purchaseorders[i].customer1 != null){
      this.customers.push(new Customer(this.purchaseorders[i].customer1));}
      if(this.purchaseorders[i].purchaseOrderQuantityStatusCodeID != null){
      this.status.push(new Status(this.purchaseorders[i].purchaseOrderQuantityStatusCodeID));}

    }

    const distinctdistributors = this.distributors.filter(
      (thing, i, arr) => arr.findIndex(t => t.distributor === thing.distributor) === i
    );
    this.distributornames = distinctdistributors;
    this.distributornamesClone = this.distributornames ;
    const distinctcustomers = this.customers.filter(
      (thing, i, arr) => arr.findIndex(t => t.customer === thing.customer) === i
    );
    this.customernames = distinctcustomers;
    this.customernamesClone = this.customernames;
    const distinctstatus = this.status.filter(
      (thing, i, arr) => arr.findIndex(t => t.status === thing.status) === i
    );
    //this.statusvalues = distinctstatus;
    this.statusvaluesClone = this.statusvalues ;
    this.isDistributorAvl = false;
 }



searchValidation(){

  this.serachdetails.forEach(partner => {
    let localparnter=partner.purchaseOrderNumber;
    console.log(localparnter.replace(/\s/g, "").toLowerCase()
      +"<<-->>>"+this.search.toString().replace(/\s/g, "").toLowerCase());
      console.log(localparnter.replace(/\s/g, "").toLowerCase() !== this.search.toString().replace(/\s/g, ''));
    if (localparnter.replace(/\s/g, "").toLowerCase() !== this.search.toString().replace(/\s/g, '')) {

      console.log(localparnter.replace(/\s/g, "").toLowerCase()
        +"------>>>>>"+this.search.toString().replace(/\s/g, "").toLowerCase());

      this.dateValitation = true;
}
});

  if ( this.dateValitation && this.search.length >=3) {
    console.log("3-->> Data validation..");
        this.daterange = { start: moment().subtract(this.appSettingService.m2mDbSearchKeyDaysLimit, 'days'), end: moment() };
        this.dateValitation = false;
      } else {
        this.daterange = '';
      }
}



  selectCustomeAndStatus(selecteddistributor){
    if(selecteddistributor==""){
    console.log(" if selecteddistributor"+selecteddistributor);
    this.customernames= this.customernamesClone;
    //this.statusvalues = this.statusvaluesClone;
    }else{

      console.log("else   selecteddistributor"+selecteddistributor);
     var size = this.purchaseorders.length;
     this.customers=[];
     this.status=[];
     for(var i=0; i<size; i++){
       if(this.purchaseorders[i].customer1 != "" &&  this.purchaseorders[i].customer1 != null){
        this.customers.push(new Customer(this.purchaseorders[i].customer1));
       }
       if(this.purchaseorders[i].purchaseOrderQuantityStatusCodeID != "" && this.purchaseorders[i].purchaseOrderQuantityStatusCodeID != null){
        this.status.push(new Status(this.purchaseorders[i].purchaseOrderQuantityStatusCodeID));
       }
     }
     const distinctcustomers = this.customers.filter(
      (thing, i, arr) => arr.findIndex(t => t.customer === thing.customer) === i
    );
    this.customernames = distinctcustomers;
    const distinctstatus = this.status.filter(
      (thing, i, arr) => arr.findIndex(t => t.status === thing.status) === i
    );
    //this.statusvalues = distinctstatus;
    }

  }
  selectDistributorAndStatus(selectedcustomer1){
    if(selectedcustomer1==""){
      console.log(" if selecteddistributor"+selectedcustomer1);
      this.distributornames = this.distributornamesClone;
      //this.statusvalues = this.statusvaluesClone;
      }else{

        console.log("else   selecteddistributor"+selectedcustomer1);
       var size = this.purchaseorders.length;
       this.distributors=[];
       this.status=[];
       for(var i=0; i<size; i++){
         if(this.purchaseorders[i].payer1 != "" &&  this.purchaseorders[i].payer1 != null){
          this.distributors.push(new Distributor(this.purchaseorders[i].supplierSoldToId));
         }
         if(this.purchaseorders[i].purchaseOrderQuantityStatusCodeID != "" && this.purchaseorders[i].purchaseOrderQuantityStatusCodeID != null){
          this.status.push(new Status(this.purchaseorders[i].purchaseOrderQuantityStatusCodeID));
         }
       }
       const distinctdistributors = this.distributors.filter(
        (thing, i, arr) => arr.findIndex(t => t.distributor === thing.distributor) === i
      );
      this.distributornames = distinctdistributors;
      const distinctstatus = this.status.filter(
        (thing, i, arr) => arr.findIndex(t => t.status === thing.status) === i
      );
      //this.statusvalues = distinctstatus;
      }


  }
  selectDistributorAndCustomer(selectedstatus){    
    if(selectedstatus==""){
      console.log(" if selecteddistributor"+selectedstatus);
      this.distributornames = this.distributornamesClone;
      this.customernames = this.customernamesClone;
      }else{

        console.log("else   selecteddistributor"+selectedstatus);
       var size = this.purchaseorders.length;
       this.distributors=[];
       this.customers=[];
       for(var i=0; i<size; i++){
         if(this.purchaseorders[i].payer1 != "" &&  this.purchaseorders[i].payer1 != null){
          this.distributors.push(new Distributor(this.purchaseorders[i].supplierSoldToId))
         }
         if(this.purchaseorders[i].customer1 != "" && this.purchaseorders[i].customer1 != null){
          this.customers.push(new Customer(this.purchaseorders[i].customer1));
         }
       }
       const distinctdistributors = this.distributors.filter(
        (thing, i, arr) => arr.findIndex(t => t.distributor === thing.distributor) === i
      );
      this.distributornames = distinctdistributors;
      const distinctcustomers = this.customers.filter(
        (thing, i, arr) => arr.findIndex(t => t.customer === thing.customer) === i
      );
      this.customernames = distinctcustomers;
      }


  }
  selectedistributor() {

    this.clearAllSelection();
    this.fileExportService.selectedPoData = [];
    this.clearAllSort();
    this.purchaseorders = this.clonedpurchaseorders;
    let distributorlist: Purchaseorderdto[] = [];
    let len = this.purchaseorders.length;
    if (this.selecteddistributor != "" && this.selectedcustomer1 != "" && this.selectedstatus != "") {
      for (let i = 0; i < len; i++) {
        if (this.purchaseorders[i].supplierSoldToId == this.selecteddistributor && this.purchaseorders[i].customer1 == this.selectedcustomer1 && this.purchaseorders[i].purchaseOrderQuantityStatusCodeID == this.selectedstatus) {
          distributorlist.push(this.purchaseorders[i]);
        }
      }
      this.purchaseorders = distributorlist;
    }
    else if (this.selecteddistributor != "" && this.selectedcustomer1 != "") {
      for (let i = 0; i < len; i++) {
        if (this.purchaseorders[i].supplierSoldToId == this.selecteddistributor && this.purchaseorders[i].customer1 == this.selectedcustomer1) {
          distributorlist.push(this.purchaseorders[i]);
        }
      }
      this.purchaseorders = distributorlist;
    }
    else if (this.selecteddistributor != "" && this.selectedstatus != "") {
      for (let i = 0; i < len; i++) {
        if (this.purchaseorders[i].supplierSoldToId == this.selecteddistributor && this.purchaseorders[i].purchaseOrderQuantityStatusCodeID == this.selectedstatus) {
          distributorlist.push(this.purchaseorders[i]);
        }
      }
      this.purchaseorders = distributorlist;
    }
    else if (this.selectedcustomer1 != "" && this.selectedstatus != "") {
      for (let i = 0; i < len; i++) {
        if (this.purchaseorders[i].customer1 == this.selectedcustomer1 && this.purchaseorders[i].purchaseOrderQuantityStatusCodeID == this.selectedstatus) {
          distributorlist.push(this.purchaseorders[i]);
        }
      }
      this.purchaseorders = distributorlist;
    }
    else if (this.selecteddistributor != "") {
      for (let i = 0; i < len; i++) {
        if (this.purchaseorders[i].supplierSoldToId == this.selecteddistributor) {
          distributorlist.push(this.purchaseorders[i]);
        }
      }
      this.purchaseorders = distributorlist;
    }
    else if (this.selectedcustomer1 != "") {
      for (let i = 0; i < len; i++) {
        if (this.purchaseorders[i].customer1 == this.selectedcustomer1) {
          distributorlist.push(this.purchaseorders[i]);
        }
      }
      this.purchaseorders = distributorlist;
    }
    else if (this.selectedstatus != "") {
      for (let i = 0; i < len; i++) {
        if (this.purchaseorders[i].purchaseOrderQuantityStatusCodeID == this.selectedstatus) {
          distributorlist.push(this.purchaseorders[i]);
        }
      }
      this.purchaseorders = distributorlist;
    }


  }

  datereangeselectionforpo(search) {
    // if(this.search != '' || this.search != undefined || this.search != null){
    //   this.showMessage = "Please Select Date Range";
    //   return
    // }
    this.selectedstatus = '';
    if(this.inOrderDetails != "orderDetails"){
    this.fileExportService.selectedPoData = [];
    this.purchaseorders=[];
    if(this.numberofexecution != 1 && (search.value != '' || search.value != undefined || search.value != null)){
      this.isLessOrMoreDate = '';
      this.clearAllSelection();

      let sysdate = moment();

      let startdate1 = this.daterange.start;
      let enddate1 = this.daterange.end;

      let threemonthbeforefromsystemdate = moment(enddate1).subtract(90, 'days');
      // if(enddate1 > sysdate){
      //   this.isLessOrMoreDate = "Selected Date should not be more than current date";
      //   this.loading=false;
      //   return;
      // }
      console.log('.start date...'+startdate1+'....end..'+ moment(enddate1).subtract(90, 'days'));
      if (threemonthbeforefromsystemdate >= startdate1) {

        this.isLessOrMoreDate = 'Date range must be less than 90 days';
      } else {
        this.isLessOrMoreDate = '';
        if(this.daterange.start != null && this.daterange.end !=null ) {

        let startdate = this.daterange.start.format('YYYY-MM-DD');
        let enddate = this.daterange.end.format('YYYY-MM-DD');
        this.loading=true;
        
        this.httpclientService.datereangeselectionforpo(startdate, enddate, this.username, search.value).subscribe(
          data => {
            this.loading = false;
            this.clearAllSort();
            this.purchaseorders = [];
            this.purchaseorders = data;
            this.intialPurchaseOrderList = data;
            this.removeDuplicates();
            this.clonedpurchaseorders = Object.assign([{}], this.purchaseorders);
            this.cancelthesearach = Object.assign([{}], this.purchaseorders);
            this.numberofexecution = this.numberofexecution + 1;
            if(this.purchaseorders.length === 0) {
              this.isLessOrMoreDate = 'No Record Found';
            }
            this.loading=false;

          }
        )
      }
    }
  }
}
  }
  cancelserach(count,search){
     console.log("5-->>");
     this.showMessage="";
     if(count == 2 && search.length >=3){

      this.purchaseorders =this.intialPurchaseOrderListOne;
    }
     this.setSearch('');
     this.searchFlag = false;



  }

  isNullValueEvent(){
    this.isXmlDataNotAvailable = false;
  }

  downloadPdf(pdfUrl: string, pdfName: string ) {
    //const pdfUrl = './assets/sample.pdf';
    //const pdfName = 'your_pdf_file';
    FileSaver.saveAs(pdfUrl, pdfName);
  }
}
